import './App.css';
import './Other.css';
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import React from 'react';
import { csv } from 'csvtojson';
import { SliderComponent } from '@syncfusion/ej2-react-inputs';
import { Coronakarte } from "./Coronakarte";
import { Search } from './Search';
import { getUrlParam } from './urlparams';
import { Scale } from './Scale';
import { Modal } from './Modal';
import {KreisPreview} from "./KreisPreview";
import {Popup} from "react-leaflet";
import L from 'leaflet';
// import ReactGA from 'react-ga';

export class App extends React.Component {
    constructor(props) {
        super(props);

        this.breakingPoint = 750
        this.screenHeight = window.innerHeight;
        this.state = {}

        this.map = getUrlParam('map')

        // ReactGA.initialize('UA-2696235-47', {
        //     anonymizeIp: true
        // });
        // ReactGA.pageview(window.location.pathname + window.location.search);

        if (!['Deutschland', 'NRW'].includes(this.map)) {
            this.map = 'Deutschland'
        }
        this.branding = getUrlParam('branding')

        this.tooltipChangeHandler = this.tooltipChangeHandler.bind(this);
        this.handleSearchResClick = this.handleSearchResClick.bind(this);
        this.closeSearch = this.closeSearch.bind(this);
        this.selectKreis = this.selectKreis.bind(this);
        this.set_showModal = this.set_showModal.bind(this);

        this.CoronakarteRef = React.createRef();
    }

    componentDidMount() {
        fetch(process.env.PUBLIC_URL + '/verlauf_start' + (this.map === 'NRW' ? '_nrw' : '') + '.csv')
            .then(res => res.text())
            .then(csvStr => {
                csv({checkType: true, delimiter: [','], quote: '"'})
                    .fromString(csvStr)
                    .then(csvRows => {
                        this.verlauf_start = csvRows;
                    })
            })

        fetch(process.env.PUBLIC_URL + '/' + this.map.toLowerCase() + '.json')
            .then(res => res.json())
            .then(geojson => {
                this.setState({
                    geojson: geojson
                })
                this.processData()
            })
        fetch(process.env.PUBLIC_URL + '/grossstaedte_' + this.map.toLowerCase() + '.json')
            .then(res => res.json())
            .then(json => {
                const stadtMarker = [];
                json.features.forEach(label => {
                    let marker = new L.divIcon({
                        className: 'custom-div-icon',
                        html: "<p class='stadtteil-marker'>" + label.properties.City + "</p>",
                        iconSize: [100, 16],
                        iconAnchor: [50, 8]
                    })
                    stadtMarker.push(marker)
                })
                this.setState({
                    stadtlabels: json.features,
                    stadtMarker: stadtMarker
                })
            })
        // fetch(
        //     'https://interaktiv.rp-online.de/python/coronavirus-maps/verlauf.csv',
        //     {
        //       headers: {
        //         'Cache-Control': 'no-cache, no-store, must-revalidate',
        //         'Pragma': 'no-cache',
        //         'Expires': 0
        //       }
        //     })
        fetch(process.env.PUBLIC_URL + '/verlauf' + (this.map === 'NRW' ? '_nrw' : '') + '.csv')
            .then(res => res.text())
            .then(csvStr => {
              csv({checkType: true, delimiter: [','], quote: '"'})
                  .fromString(csvStr)
                  .then(csvRows => {
                      this.verlauf = csvRows;
                      this.processData();
                  })
            })

        if (this.map === 'Deutschland') {
            fetch(process.env.PUBLIC_URL + '/deutschland_citylabel.json')
                .then(res => res.json())
                .then(json => {
                    const stadtMarker = [];
                    json.features.forEach(label => {
                        let marker = new L.divIcon({
                            className: 'custom-div-icon',
                            html: "<p class='stadtteil-marker'>" + label.properties.City + "</p>",
                            iconSize: [100, 16],
                            iconAnchor: [50, 8]
                        })
                        stadtMarker.push(marker)
                    })

                    this.setState({
                        city_stadtlabels: json.features,
                        city_stadtMarker: stadtMarker
                    })
                })
        }
    }

    processData() {
        if (this.verlauf_start && this.verlauf) {
            let kreise = {};
            this.verlauf_start.forEach(function (row) {
                kreise[row.ags] = row;
            })

            let max_inzidenz = 1;
            let min_date_str = this.verlauf[0].Datum;
            let max_date_str = this.verlauf[0].Datum;
            let first_ags = this.verlauf[0].AGS


            this.verlauf.forEach(function (row) {
                // console.log('ags', row.AGS, kreise[row.AGS])
                if (row.AGS) {
                    let inzidenz = row.last_7 * 100000 / kreise[row.AGS].population;
                    if (inzidenz > max_inzidenz) {
                        max_inzidenz = inzidenz;
                    }
                    if (row.AGS === first_ags) {
                        max_date_str = row.Datum;
                    }
                    kreise[row.AGS][row.Datum] = {inzidenz: inzidenz, last_7: row.last_7};
                }
            })

            let min_date = new Date(min_date_str).getTime();
            let max_date = new Date(max_date_str).getTime();
            let diffDays = Math.ceil(Math.abs(max_date - min_date) / (1000 * 60 * 60 * 24));

            let steps = 4;

            if (window.innerWidth < 360) {
                steps = 2;
            } else if (window.innerWidth < 420) {
                steps = 3;
            }
            this.setState({
                kreise: kreise,
                min_date: min_date,
                max_date: max_date,
                max_inzidenz: max_inzidenz,
                selected_date: max_date_str,
                TicksDataModel: { placement: "After", largeStep: (diffDays / steps) * 86400000 }
            })
        }
    }

    renderingTicksHandler(args: SliderTickEventArgs) {
        let totalMiliSeconds = Number(args.value);
        // Converting the current milliseconds to the respective date in desired format
        let custom = { year: "numeric", month: "short", day: "numeric" };
        args.text = new Date(totalMiliSeconds).toLocaleDateString("de-de", custom);
    }

    tooltipChangeHandler(args: SliderTooltipEventArgs) {
        let totalMiliSeconds = Number(args.text);
        // Converting the current milliseconds to the respective date in desired format
        let custom = { year: "numeric", month: "short", day: "numeric" };
        args.text = new Date(totalMiliSeconds).toLocaleDateString("de-de", custom);
        this.setState({
            selected_date: new Date(totalMiliSeconds).toISOString().split('T')[0]
        })
    }

    handleSearchResClick(kreis) {
        this.CoronakarteRef.current.setToStartZoom();
        this.CoronakarteRef.current.selectKreis(kreis, null, true);
    }

    closeSearch() {
        this.CoronakarteRef.current.closePopup();
        this.setState({selected_kreis: null})
    }

    selectKreis(kreis) {
        this.setState({selected_kreis: kreis})
    }

    set_showModal(show) {
        this.setState(({showModal: show}))
    }

    render() {
        if (!this.state.kreise || !this.state.geojson) {
            return (
                <div className="App" style={{height: this.screenHeight.toString() + 'px'}}>
                    <div className="lds-ellipsis large-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )
        }

        return (
            <div>
                <Modal
                    showModal={this.state.showModal}
                    set_showModal={this.set_showModal}
                    screenHeight={this.screenHeight}
                />
                <div className="App"
                     style={
                         this.state.selected_kreis && window.innerWidth < 750
                         ? {height: (this.screenHeight * 0.8).toString() + "px"}
                         : {height: this.screenHeight.toString() + "px"}
                     }
                >
                    {!(getUrlParam('gestureHandling')) &&
                    <>
                        {getUrlParam('showBackLink') &&
                        <div className="goback-link marginleft">
                            <a href="javascript:history.back()" className="link"><b>← Zurück zur vorherigen Ansicht</b></a>
                        </div>
                        }
                        <div className="head marginleft margintop">
                            {'GA' === this.branding
                                ? <img className="iconGA" alt="Logo der Website"
                                       src={process.env.PUBLIC_URL + '/GA-Logo.png'}/>
                                : ('AZ' === this.branding)
                                    ? <img className="icon" style={{width: "103px"}} alt="Logo der Website"
                                           src={process.env.PUBLIC_URL + '/Logo_AZ_AN.png'}/>
                                    : <img className="icon" alt="Logo der Website"
                                           src="https://interaktiv.rp-online.de/europawahl-2019/ergebnisse/nrw/img/rp-logo.svg"/>
                            }
                            <div className="border-left">
                                <h2>Interaktive Karte</h2>
                                <h1>Die Entwicklung des Coronavirus in {this.map}</h1>
                            </div>
                        </div>
                    </>
                    }
                    <Coronakarte
                        ref={this.CoronakarteRef}
                        geojson={this.state.geojson}
                        breakingPoint={this.breakingPoint}
                        max_inzidenz={this.state.max_inzidenz}
                        selected_date={this.state.selected_date}
                        kreise={this.state.kreise}
                        selectKreis={this.selectKreis}
                        stadtlabels={this.state.stadtlabels}
                        stadtMarker={this.state.stadtMarker}
                        city_stadtlabels={this.state.city_stadtlabels}
                        city_stadtMarker={this.state.city_stadtMarker}
                        screenHeight={this.screenHeight}
                        map={this.map}

                    />
                    <div className="info-column">
                        <div className="info-column-head margintop marginright">
                            <Search
                                kreise={this.state.kreise}
                                handleSearchResClick={this.handleSearchResClick}
                                closeSearch={this.closeSearch}
                                // removeBezirkLine={this.removeBezirkLine}
                                // changeBezirk={this.changeBezirk}
                            />
                            <div
                                className="infoBtn mouse-pointer"
                                onClick={() => this.set_showModal(true)}
                            ><b>i</b></div>
                        </div>
                    </div>
                    <div className="dateslider-wrap rounded border">
                        <SliderComponent
                            id="circle_slider"
                            type="MinRange"
                            min={this.state.min_date}
                            max={this.state.max_date}
                            value={this.state.max_date}
                            step={86400000}
                            tooltip={{placement: "Before", isVisible: true, showOn: "Auto"}}
                            ticks={this.state.TicksDataModel}
                            tooltipChange={this.tooltipChangeHandler}
                            renderingTicks={this.renderingTicksHandler}
                        />
                    </div>
                    <Scale
                        max_value={this.state.max_inzidenz}
                        selected_date={this.state.selected_date}
                        kreis={this.state.selected_kreis}
                    />
                </div>
                <div className="mobilePreviewWrapper border">
                    <KreisPreview
                        kreis={this.state.selected_kreis}
                        selected_date={this.state.selected_date}
                        showCloseIcon={true}
                        closePopup={this.closeSearch.bind(this)}
                    />
                </div>
            </div>
        );
    }
}

export default App;